import { temAcesso } from '@/shared/auth/temAcesso'

const PainelErrosComprometimentos = () =>
    import('./PainelErrosComprometimentos.vue')

export default {
    path: 'paineis',
    name: 'Sgtec_Gestores_Paineis',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('SGTEC-GEST-PNL-00')) {
            next()
        }
    },
    children: [
        {
            path: 'erroscomprometimentos',
            name: 'Sgtec_Gestores_Paineis_Erros_Comprometimentos',
            component: PainelErrosComprometimentos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('SGTEC-GEST-PNL-01')) {
                    next()
                }
            }
        }
    ]
}
